import { render } from "./ui-scroll.vue?vue&type=template&id=388530d0&scoped=true&ts=true"
import script from "./ui-scroll.vue?vue&type=script&lang=ts"
export * from "./ui-scroll.vue?vue&type=script&lang=ts"

import "./ui-scroll.vue?vue&type=style&index=0&id=388530d0&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388530d0"]])

export default __exports__